import { defineRelease } from '../types'

export default defineRelease({
  version: '2026.10.3',
  date: '2026-10-05',
  summary: 'Clients can have several email domains.',
  entries: [
    {
      id: 'client-multiple-domains',
      type: 'new',
      module: 'helpdesk',
      title: 'Link several email domains to one client',
      body: 'Add every domain a client emails from, like acme.com and acme.io. Tickets from any of them, or their subdomains, are linked to that client automatically, and show up for the client’s portal users who can see all client requests. Matching ignores capital letters, www. and https://.',
      link: { to: '/clients', label: 'Open Clients' },
      roles: ['iam_org_admin', 'iam_superadmin', 'ticketing_admin', 'lead_agent', 'ticketing_agent'],
      service: 'client-mgmt',
    },
  ],
})
